import * as React from "react"
import type { SVGProps } from "react"
export const SpinnerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 22a9.676 9.676 0 01-3.875-.788 10.144 10.144 0 01-3.188-2.15 10.142 10.142 0 01-2.15-3.187A9.676 9.676 0 012 12c0-1.383.263-2.68.788-3.887a10.183 10.183 0 012.15-3.175 10.143 10.143 0 013.187-2.15A9.676 9.676 0 0112 2c.283 0 .52.096.713.288.191.191.287.429.287.712s-.096.52-.287.712A.968.968 0 0112 4c-2.217 0-4.104.78-5.662 2.338C4.779 7.896 4 9.783 4 12s.78 4.104 2.338 5.663C7.896 19.22 9.783 20 12 20s4.104-.78 5.663-2.337C19.22 16.104 20 14.217 20 12c0-.283.096-.52.288-.713A.968.968 0 0121 11c.283 0 .52.096.712.287.192.192.288.43.288.713a9.676 9.676 0 01-.788 3.875 10.143 10.143 0 01-2.15 3.188 10.184 10.184 0 01-3.175 2.15A9.649 9.649 0 0112 22z"
    />
  </svg>
)
